export function computeDropPosition(cardsInTargetList, dropIndex) {
  const sorted = [...cardsInTargetList].sort((a, b) => a.position - b.position);
  if (sorted.length === 0) return 0;
  if (dropIndex <= 0) return sorted[0].position - 1;
  if (dropIndex >= sorted.length) return sorted[sorted.length - 1].position + 1;
  return Math.floor(
    (sorted[dropIndex - 1].position + sorted[dropIndex].position) / 2
  );
}
